import { injectGlobal } from '@bd/bdui-styles/emotion';
import colors from './colors';
import typography from './typography';

injectGlobal(`
  body {
    color: #272626;
  }
  .Btn {
    background-color: ${colors.color1};
    font-family: ${typography.SansSerif};
    text-transform: uppercase;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 3px;
    padding: 15px 20px;
    line-height: 15px;
    text-align: center;
    display: block;
    transition: all .3s ease-in;
    width: auto;
    @media (min-width: 768px) {
      padding: 20px 15px;
      font-size: 16px;
      cursor: pointer;
    }
    &:hover {
      background-color: ${colors.color2Darkest};
      color: #FFFFFF;
    }
    &:focus {
      outline: none;
    }
  }

  .Hollow {
    font-family: ${typography.SansSerif};
    border: solid 3px ${colors.color1Lighter};
    color: ${colors.color1};
    font-weight: 700;
    letter-spacing: .2px !important;
    text-transform: none;
    background-color: transparent;
    background-image: none;
    font-size: 18px;
    &:hover {
      background-color: ${colors.color1Lighter};
      color: ${colors.white};
    }
  }

  .CenterText {
    text-align: center;
  }

  .clearfix::after {
    content: '';
    display: table;
    clear: both;
  }
  a {
    transition: all .3s ease-in;
    text-decoration: none;
    color: ${colors.color1};
  }
  a:hover {
    color: ${colors.color1Light};
    text-decoration: none;
    border: none;
  }
  p {
    color: #272626;
    font-size: 16px;
    font-weight: 300;
    line-height: 1.2;
    letter-spacing: .5px;
  }

  .PageSection_title {
    font-family: ${typography.SansSerif};
    color: ${colors.color1};
    font-weight: 200;
    text-transform: uppercase;
    font-size: 30px;
    margin-bottom: 0;
    letter-spacing: 1.3px;
    margin-bottom: 15px;
    @media (min-width: 992px) {
      font-size: 32px;
      margin-bottom: 20px;
    }
    @media (min-width: 1200px) {
      font-size: 38px;
    }
  }
  .PageSection_copy p {
    font-weight:300;
    font-size: 18px;
    line-height: 22px;
    @media(min-width:992px) {
      font-size: 20px;
      line-height: 26px;
    }
  }
  .MapSection_directions p {
    font-weight:300;
    font-size: 18px;
    line-height: 22px;
    @media(min-width:992px) {
      font-size: 20px;
      line-height: 26px;
    }
  }

`);



// WEBPACK FOOTER //
// ./src/styles/reset.js